import React from 'react';
import './index.scss';
import clsx from 'clsx';

const TextAreaInput = ({ 
  name,
  value,
  onChange, 
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  inValid = false, 
  suggestText = false,
  rows,
  cols,
}) => {
  return (
    <div className="TextAreaInput">
      <textarea
        cols={cols}
        rows={rows}
        autoComplete="off"
        name={name} 
        value={value} 
        onChange={onChange} 
        onInput={onInput}
        onCompositionEnd={onCompositionEnd}
        maxLength={maxLength} 
        placeholder={placeholder} 
        className={clsx({ inValid })}
        id={clsx({ suggestText })}
      />
    </div>
  );
};
export default TextAreaInput;